module.exports = __webpack_public_path__ + "static/media/elevus.91197f1c.png";